// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"bb03c91b","703":"e1b077bf","787":"9e9f4ffd"}[chunkId] + ".chunk.js";
};